"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addConsignmentAttachmentActivityBucketSchema = exports.JoinBusinessActivityBucketSchema = exports.EditPluginActivityBucketSchema = exports.DeactivatePluginActivityBucketSchema = exports.ActivatePluginActivityBucketSchema = exports.GenerateCodeActivityBucketSchema = exports.StatusActivityBucketSchema = exports.OutConsignmentActivityBucketSchema = exports.LinkProductActivityBucketSchema = exports.AngusAIJoiningActivityBucketSchema = exports.TransTokenActivityBucketSchema = exports.DelTokenActivityBucketSchema = exports.RemoveTagActivityBucketSchema = exports.AddTagActivityBucketSchema = exports.ReplaceTagActivityBucketSchema = exports.UploadCsvActivityBucketSchema = exports.HeightActivityBucketSchema = exports.TreatmentActivityBucketSchema = exports.DeceaseActivityBucketSchema = exports.PregnancyActivityBucketSchema = exports.WeightActivityBucketSchema = exports.MovementActivityBucketSchema = exports.DeleteActivityBucketSchema = exports.UpdateActivityBucketSchema = exports.UpdateUserActivityBucketSchema = exports.activityBucketGeneralSchema = void 0;
const zod_1 = require("zod");
const ActivityLib = __importStar(require("../lib/activity"));
const ActivityMisc = __importStar(require("../misc/activity"));
const LocationMisc = __importStar(require("../misc/location"));
exports.activityBucketGeneralSchema = zod_1.z.object({
    uuid: zod_1.z.string(),
    businessId: zod_1.z.string().optional(),
    userId: zod_1.z.string(),
    count: zod_1.z.number(),
    metaData: zod_1.z.object({
        isLatest: zod_1.z.boolean(),
        startDate: zod_1.z.date(),
        endDate: zod_1.z.date()
    }),
    token: ActivityMisc.TokenLinkSchema,
    createdAt: zod_1.z.date().optional(),
    updatedAt: zod_1.z.date().optional(),
});
//Update User Activity
exports.UpdateUserActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.UP_user_details),
    details: zod_1.z.object({
        latestActivity: ActivityLib.UpdateUserActivitySchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.UpdateUserActivitySchema)
}).merge(exports.activityBucketGeneralSchema);
//Update Activity
exports.UpdateActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.UP_details),
    details: zod_1.z.object({
        latestActivity: ActivityLib.TokenDetailsSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.TokenDetailsSchema)
}).merge(exports.activityBucketGeneralSchema);
//Delete Activity
exports.DeleteActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.DEL_details),
    details: zod_1.z.object({
        latestActivity: ActivityLib.TokenDetailsSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.TokenDetailsSchema)
}).merge(exports.activityBucketGeneralSchema);
//Movement Activity
exports.MovementActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.addMovement),
    details: zod_1.z.object({
        latestActivity: ActivityLib.MovementActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.MovementActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Weight Activity
exports.WeightActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateWeight),
    details: zod_1.z.object({
        latestActivity: ActivityLib.WeightActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.WeightActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Pregnancy Activity
exports.PregnancyActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updatePregnancyStatus),
    details: zod_1.z.object({
        latestActivity: ActivityLib.PregnancyActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.PregnancyActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Decease Activity
exports.DeceaseActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateDeceaseStatus),
    details: zod_1.z.object({
        latestActivity: ActivityLib.DeceaseActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.DeceaseActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Treatment Activity
exports.TreatmentActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.addTreatment),
    details: zod_1.z.object({
        latestActivity: ActivityLib.TreatmentActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.TreatmentActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Height Activity
exports.HeightActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateHeight),
    details: zod_1.z.object({
        latestActivity: ActivityLib.HeightActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.HeightActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Upload Csv Activity
exports.UploadCsvActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.uploadcsv),
    details: zod_1.z.object({
        latestActivity: ActivityLib.UploadCsvActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.UploadCsvActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Replace Tag Activity
exports.ReplaceTagActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.replace_tag),
    details: zod_1.z.object({
        latestActivity: ActivityLib.ReplaceTagActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.ReplaceTagActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Add Tag Activity
exports.AddTagActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.add_tag),
    details: zod_1.z.object({
        latestActivity: ActivityLib.AddRemoveTagDetailDetailSchema.optional(),
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.AddRemoveTagDetailDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Remove Tag Activity
exports.RemoveTagActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.remove_tag),
    details: zod_1.z.object({
        latestActivity: ActivityLib.AddRemoveTagDetailDetailSchema.optional(),
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.AddRemoveTagDetailDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Del Token Activity
exports.DelTokenActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.DEL_token),
    details: zod_1.z.object({
        latestActivity: ActivityLib.DelTokenActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.DelTokenActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Trans Token Activity
exports.TransTokenActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.TRANS_token),
    details: zod_1.z.object({
        latestActivity: ActivityLib.TransTokenActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.TransTokenActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Angus AI Joining Activity
exports.AngusAIJoiningActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.angusAIJoining),
    details: zod_1.z.object({
        latestActivity: ActivityLib.AngusAIJoiningActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.AngusAIJoiningActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Link Product Activity
exports.LinkProductActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.linkProduct),
    details: zod_1.z.object({
        latestActivity: ActivityLib.LinkProductActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.LinkProductActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Out Consignment Activity
exports.OutConsignmentActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.outConsignment),
    details: zod_1.z.object({
        latestActivity: ActivityLib.OutConsignmentDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.OutConsignmentDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Status Activity
exports.StatusActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.updateStatus),
    details: zod_1.z.object({
        latestActivity: ActivityLib.StatusActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.StatusActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Generate Security Code Activity
exports.GenerateCodeActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.generateSecurityCode),
    details: zod_1.z.object({
        latestActivity: ActivityLib.GenerateCodeActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.GenerateCodeActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Activate Plugin Activity
exports.ActivatePluginActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.activatePlugin),
    details: zod_1.z.object({
        latestActivity: ActivityLib.ActivatePluginActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.ActivatePluginActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Deactivate Plugin Activity
exports.DeactivatePluginActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.deactivatePlugin),
    details: zod_1.z.object({
        latestActivity: ActivityLib.DeactivatePluginActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.DeactivatePluginActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Edit Plugin Activity
exports.EditPluginActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.editPlugin),
    details: zod_1.z.object({
        latestActivity: ActivityLib.EditPluginActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.EditPluginActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Join Business Activity
exports.JoinBusinessActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.join_business),
    details: zod_1.z.object({
        latestActivity: ActivityLib.JoinBusinessActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.JoinBusinessActivityDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
//Trans Token Activity
exports.addConsignmentAttachmentActivityBucketSchema = zod_1.z.object({
    type: zod_1.z.literal(ActivityLib.ActivityTypeSchema.enum.TRANS_token),
    details: zod_1.z.object({
        latestActivity: ActivityLib.TransTokenActivityDetailSchema,
        latestLocation: LocationMisc.latestLocationSchema.optional(),
        lastValidLocation: LocationMisc.latestValidLocationSchema.optional(),
        locationArea: LocationMisc.locationDataSchema.optional(),
        allHaveLocation: zod_1.z.boolean()
    }),
    activities: zod_1.z.array(ActivityLib.addConsignmentAttachmentDetailSchema)
}).merge(exports.activityBucketGeneralSchema);
